module.exports = __webpack_public_path__ + "img/collaborate_8.a71881de.jpg";